import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Button, Image } from "react-bootstrap";
import {
  Modal,
  Box,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  getUserDetail,
  editUserDetail,
  changePasswordAction,
} from "../../../../redux/Auth/AuthSlice";
import {
  getNationalityDetail,
  getCountryValueDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import { useTranslation } from "react-i18next";
import { BsPencilSquare } from "react-icons/bs";
import { FaUpload } from "react-icons/fa";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import leafLeft from "../../../../Asset/icon/leafLeft.svg";
import leafRight from "../../../../Asset/icon/leafRight.svg";
import "../../../../components/card/bookingDepositCard.scss";
import Sail from "../../../../Asset/image/yacht/Sail.gif";

const PersonalInformation = () => {
  const selectedLanguage = localStorage.getItem("selectedLanguage");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const todos = useSelector((state) => state);
  const gettoken = useSelector((state) => state.AuthSlice.token);
  const [isEdit, setIsEdit] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const UserData = todos.AuthSlice.user;
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    birthDate: "",
    gender: "",
    passportId: "",
    email: "",
    mobile: "",
    nationality: "",
    country: "",
    address: "",
  });
  const [open, setOpen] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([
        dispatch(getUserDetail({ token: gettoken })),
        dispatch(getNationalityDetail({})),
        dispatch(getCountryValueDetail({})),
      ]);
      setLoading(false);
    };
    fetchData();
  }, [dispatch, gettoken]);

  useEffect(() => {
    const UserData = todos.AuthSlice.user;
    if (UserData) {
      setFormData({
        firstName: UserData?.firstname || "",
        lastName: UserData?.lastname || "",
        birthDate: UserData?.date_of_birth
          ? formatDateForInput(UserData?.date_of_birth)
          : "",
        gender: UserData?.gender || "",
        passportId: UserData?.id_passport || "",
        email: UserData?.email || "",
        mobile: UserData?.mobile_no || "",
        nationality: UserData?.idNationality || "",
        country: UserData?.country_value || "",
        address: UserData?.address || "",
      });
    }
  }, [UserData]);

  const getNationalityName = (nationalityId) => {
    const nationalityResult = todos.CenterDataSlice.Nationality.results;
    const nationality = nationalityResult?.find(
      (item) => item.idNationality === nationalityId
    );
    if (nationality) {
      return selectedLanguage === "th"
        ? nationality.nationality_name_thai
        : nationality.nationality_name;
    }
    return "";
  };

  const getCountryName = (countryId) => {
    const countryResult = todos.CenterDataSlice.CountryValue.results;
    const country = countryResult?.find((item) => item.value === countryId);
    if (country) {
      return selectedLanguage === "th" ? country.label_th : country.label;
    }
    return "";
  };

  const handleToggleEdit = () => {
    setIsEdit(!isEdit);
    const UserData = todos.AuthSlice.user;
    if (UserData) {
      setFormData({
        firstName: UserData?.firstname || "",
        lastName: UserData?.lastname || "",
        birthDate: UserData?.date_of_birth
          ? formatDateForInput(UserData?.date_of_birth)
          : "",
        gender: UserData?.gender || "",
        passportId: UserData?.id_passport || "",
        email: UserData?.email || "",
        mobile: UserData?.mobile_no || "",
        nationality: UserData?.idNationality || "",
        country: UserData?.country_value || "",
        address: UserData?.address || "",
      });
    }
    setImageFile(null);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const formatDateForInput = (dateString) => {
    const [year, month, day] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  const formatDateForOutput = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${year}/${month}/${day}`;
  };

  const handleMouseEnter = () => {
    if (isEdit) {
      setIsHover(true);
    }
  };

  const handleMouseLeave = () => {
    if (isEdit) {
      setIsHover(false);
    }
  };

  const handleSave = async () => {
    const formattedFormData = {
      ...formData,
      birthDate: formatDateForOutput(formData.birthDate),
      imageFile,
    };

    const editUser = await dispatch(
      editUserDetail({ dataForm: formattedFormData, token: gettoken })
    );

    if (editUser.status) {
      window.location.reload();
      setImageFile(null);
    } else {
      alert("Failed to change user details. Please try again.");
      window.location.reload();
    }

    setIsEdit(false);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImageFile(reader.result);
    };
  };

  const togglePasswordVisibilityCP = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibilityNP = () => {
    setShowPassword2(!showPassword2);
  };

  const togglePasswordVisibilityCP2 = () => {
    setShowPassword3(!showPassword3);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      setSnackbar({
        open: true,
        message: t("fillAllFields"),
        severity: "warning",
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      setSnackbar({
        open: true,
        message: t("passwordsDoNotMatch"),
        severity: "warning",
      });
      return;
    }

    try {
      const result = await dispatch(
        changePasswordAction({
          currentPassword,
          newPassword,
          token: gettoken,
        })
      );

      if (result.status === "success") {
        setSnackbar({
          open: true,
          message: t("Password changed successfully!"),
          severity: "success",
        });
        setTimeout(() => {
          setOpen(false);
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        }, 2000);
      } else {
        setSnackbar({
          open: true,
          message: t("Failed to change password."),
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: t("errorOccurred"),
        severity: "error",
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <div className="ContainerInformation">
      <img
        className="BoatHelm-1 LogoInformation"
        draggable={false}
        src={BoatHelm}
        alt="BoatHelm"
      />
      <h3>{t("Personal Information")}</h3>
      <div className="row ">
        <div className="col-md-5 col-sm-12">
          <Form>
            <Form.Group className="mb-3 row" controlId="firstName">
              <Form.Label className="col-md-4 col-sm-4 col-form-label">
                {t("First Name")}
              </Form.Label>
              <div className="col-md-8 col-sm-8">
                <Form.Control
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  disabled={!isEdit}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 row" controlId="lastName">
              <Form.Label className="col-sm-4 col-form-label">
                {t("Last Name")}
              </Form.Label>
              <div className="col-sm-8">
                <Form.Control
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  disabled={!isEdit}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 row" controlId="birthDate">
              <Form.Label className="col-sm-4 col-form-label">
                {t("Birth Date")}
              </Form.Label>
              <div className="col-sm-8">
                <Form.Control
                  type="date"
                  name="birthDate"
                  value={formData.birthDate}
                  onChange={handleChange}
                  disabled={!isEdit}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 row" controlId="gender">
              <Form.Label className="col-sm-4 col-form-label">
                {t("Gender")}
              </Form.Label>
              <div className="col-sm-8 d-flex align-items-center">
                <Form.Check
                  inline
                  type="radio"
                  label="Male"
                  name="gender"
                  value="male"
                  checked={formData.gender === "male"}
                  onChange={handleChange}
                  disabled={!isEdit}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="Female"
                  name="gender"
                  value="female"
                  checked={formData.gender === "female"}
                  onChange={handleChange}
                  disabled={!isEdit}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 row" controlId="passportId">
              <Form.Label className="col-sm-4 col-form-label">
                {t("Passport ID")}
              </Form.Label>
              <div className="col-sm-8">
                <Form.Control
                  type="text"
                  name="passportId"
                  value={formData.passportId}
                  onChange={handleChange}
                  disabled={!isEdit}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 row" controlId="email">
              <Form.Label className="col-sm-4 col-form-label">
                {t("Email")}
              </Form.Label>
              <div className="col-sm-8">
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 row" controlId="mobile">
              <Form.Label className="col-sm-4 col-form-label">
                {t("Mobile")}
              </Form.Label>
              <div className="col-12 col-sm-8">
                <Form.Control
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  disabled={!isEdit}
                />
              </div>
            </Form.Group>
          </Form>
        </div>

        <div className="col-md-7">
          <div
            className="InformationUploadImg"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="InputUploadImg"
              disabled={!isEdit}
              id="profileImageUpload"
            />
            <label htmlFor="profileImageUpload">
              {UserData?.user_image || imageFile ? (
                <Image
                  src={imageFile || UserData?.user_image}
                  alt="Profile Picture"
                  className={`UploadImg ${isHover && isEdit ? "hidden" : ""
                    } mb-3`}
                />
              ) : (
                <div className="DontHaveProfile">
                  {t("You don't have a profile image, please upload.")}
                </div>
              )}

              {isHover && isEdit && (
                <div className="EditUploadImg">
                  <FaUpload size={30} color="white" />
                </div>
              )}
            </label>
          </div>

          <Form.Group className="mb-3 row" controlId="nationality">
            <Form.Label className="col-12 col-md-4 col-xs-12 col-form-label">
              {t("Nationality")}
            </Form.Label>
            <div className="col-md-8 col-xs-12">
              <Form.Control
                as="select"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                disabled={!isEdit}
              >
                {/* Render default option from userDetail */}
                {formData.nationality && (
                  <option
                    value={getNationalityName(parseInt(formData.nationality))}
                  >
                    {formData.nationality}
                  </option>
                )}

                {/* Render other nationality options if data exists */}
                {todos.CenterDataSlice.Nationality.results &&
                  todos.CenterDataSlice.Nationality.results.map((option) => (
                    <option
                      key={option.idNationality}
                      value={option.idNationality}
                    >
                      {selectedLanguage === "en"
                        ? option.nationality_name
                        : option.nationality_name_thai}
                    </option>
                  ))}
              </Form.Control>
            </div>
          </Form.Group>

          <Form.Group className="mb-3 row" controlId="country">
            <Form.Label className="col-12 col-md-4 col-xs-12 col-form-label">
              {t("Country")}
            </Form.Label>
            <div className="col-md-8 col-xs-12 ">
              <Form.Control
                as="select"
                name="country"
                value={formData.country}
                onChange={handleChange}
                disabled={!isEdit}
              >
                {/* Render default option from userDetail */}
                {formData.country && (
                  <option value={getCountryName(parseInt(formData.country))}>
                    {formData.country}
                  </option>
                )}

                {/* Render other nationality options if data exists */}
                {todos.CenterDataSlice.CountryValue.results &&
                  todos.CenterDataSlice.CountryValue.results.map((option) => (
                    <option key={option.value} value={option.value}>
                      {selectedLanguage === "en"
                        ? option.label
                        : option.label_th}
                    </option>
                  ))}
              </Form.Control>
            </div>
          </Form.Group>

          <Form.Group className="mb-3 row" controlId="address" rowSpan={2}>
            <Form.Label className="col-12 col-md-4 col-xs-12 col-form-label">
              {t("Address")}
            </Form.Label>
            <div className="col-md-8 col-xs-12">
              <Form.Control
                as="textarea"
                rows={2}
                name="address"
                value={formData.address}
                onChange={handleChange}
                disabled={!isEdit}
              />
            </div>
          </Form.Group>

          <div className="col-xs-12 order-1 ">
            {isEdit ? (
              <div className="d-flex justify-content-between button-step1">
                <Button
                  variant="primary"
                  className="col-5 mb-3 button-Save"
                  onClick={handleSave}
                >
                  {t("Save")}
                </Button>
                <Button
                  variant="secondary"
                  className="col-5 mb-3 button-Cancel"
                  onClick={handleToggleEdit}
                >
                  {t("Cancel")}
                </Button>
              </div>
            ) : (
              <div className="d-flex justify-content-between button-step1">
                <Button
                  variant="primary"
                  className="mb-3 col-md-12 col-xs-12 button-Save"
                  onClick={handleToggleEdit}
                >
                  {t("Edit Personal Information")}
                </Button>
              </div>
            )}
          </div>
          <div className="col-xs-12 button-step1">
            <Button
              className="mb-3 col-md-12 col-xs-12 button-Cancel"
              variant="secondary col-sm-12"
              onClick={handleOpen}
            >
              {t("Change Password")}
            </Button>
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="change-password-title"
        aria-describedby="change-password-description"
      >
        <Box className="BoxChangePassword">
          <IconButton className="btn-close-cpa2" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <div className="d-flex align-items-center centerAlign">
            <img
              className="img-fluid"
              draggable={false}
              src={leafLeft}
              alt="leftImage"
            />
            <h3 className="textColorPrimary m-2"> {t("Change Password")}</h3>
            <img
              className="img-fluid"
              draggable={false}
              src={leafRight}
              alt="rightImage"
            />
          </div>

          <Box component="form" className="BoxFormChangePassword">
            <TextField
              className="textField"
              fullWidth
              margin="normal"
              label={t("Current Password")}
              type={showPassword ? "text" : "password"}
              variant="outlined"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibilityCP} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className="textField"
              fullWidth
              margin="normal"
              label={t("New Password")}
              type={showPassword2 ? "text" : "password"}
              variant="outlined"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibilityNP} edge="end">
                      {showPassword2 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className="textField"
              fullWidth
              margin="normal"
              label={t("Confirm Password")}
              type={showPassword3 ? "text" : "password"}
              variant="outlined"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={togglePasswordVisibilityCP2}
                      edge="end"
                    >
                      {showPassword3 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Box className="BoxButtonChangePassword">
              <Button
                className="buttonSubmit buttonSubmitCP"
                variant="contained"
                fullWidth
                onClick={handleClose}
              >
                {t("Cancel")}
              </Button>
              <Button
                variant="contained"
                className="buttonSubmit buttonSubmitCP"
                fullWidth
                onClick={handleChangePassword}
              >
                {t("Save")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {loading && (
        <div
          className="modal-overlay"
          aria-label="Loading"
          role="status"
        >
          <img
            src={Sail} // ถ้าใช้ไฟล์ใน public ให้เปลี่ยนเป็น "/Sail.gif"
            alt="Loading..."
            className="image-modal"
            draggable={false}
          />
        </div>
      )}
    </div>
  );
};

export default PersonalInformation;
